import { publicApiRequestPendingCount } from '@api/services/public-request.service';
import { internalSupportOpenedCounter, supportOpenedCounter } from '@api/services/support.service';
import useDataQuery from '@hooks/use-data-query';

export const useSupportCounterData = () => {
    const supportCounterQuery = useDataQuery(['support-counter'], () => supportOpenedCounter());
    const internalSupportCounterQuery = useDataQuery(['internal-support-counter'], () =>
        internalSupportOpenedCounter()
    );
    const publicApiCounterQuery = useDataQuery(['requestApi-counter'], () => publicApiRequestPendingCount());

    return {
        supportCounter: supportCounterQuery.data,
        internalSupportCounter: internalSupportCounterQuery.data,
        publicApiCounter: publicApiCounterQuery.data,
        // refetch: supportCounterQuery.refetch(),
    };
};
